(() => {
  const init = () => {
    $(".slider").slick({
      prevArrow: '<div class="slide-arrow prev-arrow"></div>',
      nextArrow: '<div class="slide-arrow next-arrow"></div>'
    });
  }
  $(init);
})();
